import React, {Component} from "react";
import * as prosConnect from "./ProsConnect";
import ProsTxtTagMenu from "./ProsTxtTagMenu";
import {ATTR_OBJ_ID, ATTR_OBJ_TYPE, isValueEmpty} from "./ProsConnect";
import ProsEnumMenu from "./ProsEnumMenu";
import BasicButton from "../components/BasicButton";
import BasicModal, {BasicModalDismiss} from "../components/BasicModal";
import {getTextFieldText, isEnumSelectionType} from "./ProsCommonUi";


export default class ProsTxtTag extends Component {
    constructor(props) {
        super(props)
        this.state = {
            txt: this.props.obs[this.props.tag]
        }
    }

    modalContent = null

    isMandatoryAndMissing(){
        return this.props.project.isTxtMandatory(this.props.tag)
        && (isValueEmpty(this.state.txt) || this.state.txt === '-')
    }

    showMenu() {
        if(this.props.disabled){
            return
        }
        let project = this.props.project
        let title = 'Muokkaa'
        let textFieldType = project.getTextFieldType(this.props.tag)
        let label = project.getTxtLabel(this.props.tagIndex)
        let txtFieldCurrentValue = this.props.obs[this.props.tag]
        if (isEnumSelectionType(textFieldType)) {
            title = 'Muokkaa' // ProsEnumMenu will set dialog sub title
            this.modalContent = <ProsEnumMenu
                label={label}
                txt={txtFieldCurrentValue ?? ""}
                textFieldType={textFieldType}
                onChange={(txt)=> {
                    this.setState({
                        txt: txt
                    })
                }}
                isMandatoryAndMissing={this.isMandatoryAndMissing()}
            />
        } else {
            // default prompt as a text
            this.modalContent = <ProsTxtTagMenu
                label={label}
                txt={txtFieldCurrentValue}
                textFieldType={textFieldType}
                onCancel={()=>this.hideMenu()}
                onChange={txt => this.setState({
                    txt: txt
                })}
                isMandatoryAndMissing={this.isMandatoryAndMissing()}
            />
        }

        BasicModal(title, this.modalContent, {
            action: ()=> {
                this.props.obs[this.props.tag] = this.state.txt
                this.saveObs(this.state.txt)
            },
            //keepWidth: true //commenting out for release
        })
    }

    saveObs(txt) {
        let attrChanges = {
            [ATTR_OBJ_ID]: this.props.obs[ATTR_OBJ_ID],
            [ATTR_OBJ_TYPE]: this.props.obs[ATTR_OBJ_TYPE],
            [this.props.tag]: txt
        }
        prosConnect.getActiveProject().awaitUpdateMultipleItemsAttributes([attrChanges])
        this.setState({txt: txt})
        BasicModalDismiss()
    }

    permissionToEditTag() {
        return this.props.project.getMayEditCheckBoxOrText(this.props.tag)
    }

    render() {
        let project = this.props.project
        if (isValueEmpty(this.state.txt) && !project.isTxtMandatory(this.props.tag)) {
            return null
        }
        let btnType = !this.permissionToEditTag() ||  (project && !project.getMayEditCheckBoxOrText(this.props.tag)) ? "locked" : null
        let displayText = getTextFieldText(project, this.props.obs, this.props.tag)
        return <BasicButton
            label={<><div className={"text-xs"}>
                {this.props.project.getTxtLabels()[this.props.tagIndex]}
                </div><strong>{displayText}</strong>
            </>}
            btnClass={"custom-text btn-3rd btn-text-stacked"}
            required={this.isMandatoryAndMissing() || null}
            disabled={this.props.disabled}
            btnType={btnType}
            action={()=> this.showMenu()}
        />
    }
}